var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.about)?_c('post-body',{staticClass:"mx-2",attrs:{"html":_vm.user.about}}):_c('p',[_vm._v("Пользователь еще не заполнил информацию о себе")])}
var staticRenderFns = []

export { render, staticRenderFns }